__turbopack_context__.v({
  "link": "footerLink-module-scss-module__IoK4Ba__link",
  "linkInNewTabIcon": "footerLink-module-scss-module__IoK4Ba__linkInNewTabIcon",
});
